var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 24C8.96348 24 8.35303 23.7471 7.90294 23.2971C7.45285 22.847 7.2 22.2365 7.2 21.6H12C12 22.2365 11.7471 22.847 11.2971 23.2971C10.847 23.7471 10.2365 24 9.6 24ZM19.2 20.4H0V18L2.4 16.8V10.2C2.33678 8.50694 2.71912 6.82695 3.5088 5.328C3.8974 4.64072 4.42732 4.04365 5.06358 3.57618C5.69984 3.1087 6.42799 2.78144 7.2 2.616V0H11.5752C10.815 0.84961 10.3432 1.91803 10.2273 3.0522C10.1115 4.18638 10.3576 5.32811 10.9304 6.31385C11.5032 7.29959 12.3733 8.07875 13.416 8.53971C14.4588 9.00068 15.6206 9.11979 16.7352 8.88C16.7772 9.3084 16.7976 9.7524 16.7976 10.2V16.8L19.1976 18V20.4H19.2Z",
    fill: "#CBCCCF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 3.5,
    r: 3.5,
    fill: "#DF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.6d21b1927b7d961d5b7bd2e38391f822.svg";
export { ForwardRef as ReactComponent };